const plugin = {
  install(Vue) {
    if (this.installed) return;

    this.installed = true;
    this.emitter = new Vue();
    this.current = null;

    Vue.prototype.$modal = {
      show(modal, params) {
        plugin.emitter.$emit('toggle', modal, true, params);
        plugin.current = modal;
        return this;
      },
      showWithRoute(modal, queryAttrs = {}) {
        const { $utils, $route, $constants } = this.emitter.$nuxt;
        const modalName = modal.custom || $constants.dynamicModals[modal] || modal;

        $utils.routePushWithQuery($route, { query: { dynamic_modal: modalName, ...queryAttrs } });
        plugin.current = modalName;
        return this;
      },
      hide(name, params) {
        plugin.emitter.$emit('toggle', name || plugin.current, false, params);
        if (name === plugin.current) plugin.current = null;
        return this;
      },
      toggle(name, params) {
        plugin.emitter.$emit('toggle', name, undefined, params);
        return this;
      },
      emitter: plugin.emitter,
    };
  },
};

export default plugin;
